"use client";

type PrintableButtonProps = {
  label?: string;
};

export default function PrintableButton({ label = "Printable version" }: PrintableButtonProps) {
  return (
    <button
      className="print:hidden rounded border border-harbor px-3 py-1.5 text-sm font-semibold text-harbor transition hover:bg-tide focus:outline-none focus:ring-2 focus:ring-harbor focus:ring-offset-2"
      type="button"
      onClick={() => window.print()}
    >
      {label}
    </button>
  );
}
